import $ from 'jquery';

export default class ContentBox
{
	constructor()
	{
		let $first_multi = $('.content-box__multiple').eq(0);

		this.$buttons = $('.content-box__nav .btn');

		$('.hover-share').each((k, v) => {
			let $me = $(v),
				$template = $($me.siblings('template')[0]);

			$me.tooltipsy({
				delay: 0,
				offset: [
					0,
					0
				],
				className: 'tooltipsy-no-arrow',
				content: $template.html()
			});
		});

		$first_multi.removeClass('visually-hidden');
		this.$buttons.on('click', this.click__nav.bind(this));

        // LHS stuff

        $('.showinvite .btn').on('click', (ev) => {
            ev.preventDefault();
            // show box
            $('.showinvite').slideUp();
            $('.lhs-invite').slideDown();

        });

        $('.lhs-invite .top-right a.hide').on('click', (ev) => {
            ev.preventDefault();
            // hide box
            $('.showinvite').slideDown();
            $('.lhs-invite').slideUp();
        });

        // Prevent enter submitting
        $('.lhs-invite').on('keypress', 'input', (ev) => {
            if (13 == ev.keyCode) ev.preventDefault();
        });
	}

	click__nav(ev)
	{
		let $me = $(ev.currentTarget),
			$back_button = $('[data-inc="-1"]'),
			$fwd_button = $('[data-inc="1"]'),
			inc = Number($me.data('inc')),
			$my_nav = $me.parents('.content-box__nav'),
			$allMulti = $my_nav.siblings('.content-box__multiple'),
			$shownMulti = $allMulti.filter(':not(.visually-hidden)'),
			length = $allMulti.length,
			index;

		//$.index() does not work
		for (let i = 0; i < length; i++) {
			let $item = $($allMulti[i]);
			if ($item.hasClass('visually-hidden')) continue;
			index = i;
		}

		// are we at the ends and trying to go off the ends?
        // let's go to the first
		if (length == index + 1 && 1 == inc) {
            // Go to the first
            index = 0;
        }
        else if (0 == index && -1 == inc) {
            // Go to the last
            index = length - 1;
		}
        else {
            index += inc;
        }

		$shownMulti.addClass('visually-hidden');

		let $new_multi = $allMulti.eq(index);

		$new_multi.removeClass('visually-hidden');
	}
}
